import {AccessPointState} from './access-point/access-point.state';
import {EventsState} from './events/events-state';
import {LockdownState} from './lockdown/lockdown.state';
import {NetworksState} from './networks/networks-state';
import {PanelOutputsState} from './panel-outputs/panel-outputs.state';
import {SharedState} from './shared/shared.state';
import {UsersState} from './users/users.state';
import {ReportsState} from './reports/reports.state';

export const appStore = [PanelOutputsState, SharedState, UsersState, AccessPointState, LockdownState, NetworksState, EventsState, ReportsState];
